export enum TermsAndConditionsTranslations {
  termsAndConditionsHtml = 'termsAndConditions.termsAndConditionsHtml',
  generalTermsAndConditionsHtml = 'termsAndConditions.generalTermsAndConditionsHtml',
}
